export default "__VITE_ASSET__CBSHbWob__"